import { ServiceResponse } from '@nx-smartmonkey/shared/hooks';
import { useQuery } from '@tanstack/react-query';
import { planService } from '../../../../../application/PlanService';
import { Track } from '../../../../../domain/track/Track';
import { useAsUser } from '../../../../../hooks/session/useAsUser';
import { useRetrieveUserCredentials } from '../../../../../hooks/user/useRetrieveUserCredentials';
import { usePlanMapFilters } from './usePlanMapFilters';
import { useRetrieveActivePlan } from './useRetrieveActivePlan';

type UseRetrieveTracksResponse = ServiceResponse<() => void, Array<{ tracks: Track[]; polyline: string }>>;

export const useRetrieveActivePlanTracks = (): UseRetrieveTracksResponse => {
  const { data: userCredentials } = useRetrieveUserCredentials();
  const { data: activePlan } = useRetrieveActivePlan();
  const { mapFilters } = usePlanMapFilters();
  const { asUser } = useAsUser();

  const isAdmin = userCredentials?.isStaff(asUser);

  const { data, isSuccess, isError, isLoading, refetch } = useQuery(
    [`tracks_by_plan_${activePlan?.id}`],
    () => planService.getTracks({ planId: activePlan!.id }),
    {
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      enabled: isAdmin && !!activePlan && mapFilters.symbols.tracks,
      staleTime: Infinity,
    }
  );

  return {
    error: isError,
    isLoading,
    run: refetch,
    success: isSuccess,
    data: data ?? [],
  };
};
